import './dropZone.scss';

const DropZone = ({ visible = false, children }) => {
  if (!visible) return null;
  return <div className="drop-zone">{children}</div>;
};

export default DropZone;
